export const PERCENTS_MODES = {
	WINNERS: 'winners',
	PACKAGES: 'packages',
	STARS: 'stars',
};
